module.exports = __webpack_public_path__ + "assets/images/team/Liza1.jpg";